import type { AppError, Language } from "~/types";

export default {
  en: {
    server: 'Server error',
    bad_coupon: 'Invalid coupon code',
    expired_coupon: 'The coupon has expired',
    used_coupon: 'The coupon has already been used',
    resume_fail: 'We could not find your form. It may have expired.',
    photo_upload: 'An error occurred while uploading the photo.',
    revision: 'This form has been modified in another tab. Please refresh the page.'
  },
  ru: {
    server: 'Ошибка сервера',
    bad_coupon: 'Неверный код купона',
    expired_coupon: 'Срок действия купона истек',
    used_coupon: 'Купон уже использован',
    resume_fail: 'Мы не смогли найти вашу форму. Возможно, она истекла.',
    photo_upload: 'Произошла ошибка при загрузке фото.',
    revision: 'Эта форма была изменена в другой вкладке. Пожалуйста, обновите страницу.'
  },
  sv: {
    server: 'Serverfel',
    bad_coupon: 'Ogiltig kupongkod',
    expired_coupon: 'Kupongen har gått ut',
    used_coupon: 'Kupongen har redan använts',
    resume_fail: 'Vi kunde inte hitta ditt formulär. Det kan ha gått ut.',
    photo_upload: 'Ett fel inträffade vid uppladdning av fotot.',
    revision: 'Detta formulär har ändrats i en annan flik. Vänligen uppdatera sidan.'
  },
  he: {
    server: 'שגיאת שרת',
    bad_coupon: 'קוד קופון לא חוקי',
    expired_coupon: 'הקופון פג תוקף',
    used_coupon: 'הקופון כבר בשימוש',
    resume_fail: 'לא הצלחנו למצוא את הטופס שלך. ייתכן שהוא פג תוקף.',
    photo_upload: 'אירעה שגיאה בעת העלאת התמונה.',
    revision: 'הטופס הזה שונה בלשונית אחרת. אנא רענן את הדף.'
  }
} satisfies Record<Language, Record<AppError, string>>;